/* eslint-disable max-lines */
import { bookingActionTypes } from '../Pages/Booking/client-state/reducers/bookingReducer';
import { giftcardReducerActionTypes } from './giftcardReducer';
import { paymentReducerActionTypes } from './payment-reducer';
import { selecetedShopIdActionTypes } from './selected-shop-id-reducer';
import { termsReducerActionTypes } from './terms-reducer';
import { voucherReducerActionTypes } from './voucher-reducer';

export enum errorReducerActionTypes {
  LOCATION_MISSING = 'ERROR_LOCATION_MISSING',
  BOATCOUNT_MISSING = 'ERROR_BOATCOUNT_MISSING',
  DURATION_MISSING = 'ERROR_DURATION_MISSING',
  DATE_MISSING = 'ERROR_DATE_MISSING',
  TIME_MISSING = 'ERROR_TIME_MISSING',
  BOOKING_CREATE = 'ERROR_BOOKING_CREATE',
  BOOKING_UPDATE = 'ERROR_BOOKING_UPDATE',
  BOOKING_DATE = 'ERROR_BOOKING_DATE',
  PRICE_MODEL = 'ERROR_PRICE_MODEL',
  CUSTOMER_FORM = 'ERROR_CUSTOMER_FORM',
  TERMS = 'ERROR_TERMS',
  NEWSLETTER = 'ERROR_NEWSLETTER',
  PAYMENT = 'ERROR_PAYMENT',
  CANCEL_BOOKING = 'ERROR_CANCEL_BOOKING',
  VOUCHER = 'ERROR_VOUCHER',
  PAYMENT_INTENT = 'ERROR_PAYMENT_INTENT',
}

interface ErrorLocationMissingAction {
  type: errorReducerActionTypes.LOCATION_MISSING;
  payload: string | null;
}

interface ErrorBoatCountMissingAction {
  type: errorReducerActionTypes.BOATCOUNT_MISSING;
  payload: string | null;
}

interface ErrorDurationMissingAction {
  type: errorReducerActionTypes.DURATION_MISSING;
  payload: string | null;
}

interface ErrorDateMissingAction {
  type: errorReducerActionTypes.DATE_MISSING;
  payload: string | null;
}

interface ErrorTimeMissingAction {
  type: errorReducerActionTypes.TIME_MISSING;
  payload: string | null;
}

interface ErrorBookingCreateAction {
  type: errorReducerActionTypes.BOOKING_CREATE;
  payload: string | null;
}

interface ErrorBookingUpdateAction {
  type: errorReducerActionTypes.BOOKING_UPDATE;
  payload: string | null;
}

interface ErrorBookingDateAction {
  type: errorReducerActionTypes.BOOKING_DATE;
  payload: string | null;
}

interface ErrorPriceModelAction {
  type: errorReducerActionTypes.PRICE_MODEL;
  payload: string | null;
}

interface ErrorCustomerFormAction {
  type: errorReducerActionTypes.CUSTOMER_FORM;
  payload: string | null;
}

interface ErrorTermsAction {
  type: errorReducerActionTypes.TERMS;
  payload: string | null;
}

interface ErrorNewsletterAction {
  type: errorReducerActionTypes.NEWSLETTER;
  payload: string | null;
}

interface ErrorPaymentAction {
  type: errorReducerActionTypes.PAYMENT;
  payload: string | null;
}

interface ErrorCancelBookingAction {
  type: errorReducerActionTypes.CANCEL_BOOKING;
  payload: string | null;
}

interface ErrorVoucherAction {
  type: errorReducerActionTypes.VOUCHER;
  payload: string | null;
}

interface ErrorPaymentIntentAction {
  type: errorReducerActionTypes.PAYMENT_INTENT;
  payload: string | null;
}

interface BookingUpdateBoatCountAction {
  type: bookingActionTypes.UPDATE_BOAT_COUNT;
  payload: number;
}

interface BookingUpdateDurationAction {
  type: bookingActionTypes.UPDATE_DURATION;
  payload: number;
}

interface GiftcardUpdateDurationAction {
  type: giftcardReducerActionTypes.UPDATE_DURATION;
  payload: number;
}

interface BookingUpdateDateAction {
  type: bookingActionTypes.UPDATE_DATE;
  payload: string;
}

interface SelectedShopIdUpdateShopIdAction {
  type: selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE;
  payload: string;
}

interface TermsUpdateTermsCheckedAction {
  type: termsReducerActionTypes.UPDATE_TERMS_CHECKED;
  payload: boolean;
}

interface TermsUpdateNewsletterSubscribedAction {
  type: termsReducerActionTypes.UPDATE_NEWSLETTER_SUBSCRIBED;
  payload: boolean;
}

interface VoucherUpdateIsOpenAction {
  type: voucherReducerActionTypes.UPDATE_IS_OPEN;
  payload: boolean;
}

interface VoucherUpdateCodeAction {
  type: voucherReducerActionTypes.UPDATE_CODE;
  payload: string;
}

interface PaymentUpdateClientSecretAction {
  type: paymentReducerActionTypes.UPDATE_CLIENT_SECRET;
  payload: string;
}

interface PaymentUpdateShowPaymentModalAction {
  type: paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL;
  payload: boolean;
}

export type ErrorReducerAction =
  | ErrorLocationMissingAction
  | ErrorBoatCountMissingAction
  | ErrorDurationMissingAction
  | ErrorDateMissingAction
  | ErrorTimeMissingAction
  | ErrorBookingCreateAction
  | ErrorBookingUpdateAction
  | ErrorBookingDateAction
  | ErrorPriceModelAction
  | ErrorCustomerFormAction
  | ErrorTermsAction
  | ErrorNewsletterAction
  | ErrorPaymentAction
  | ErrorCancelBookingAction
  | ErrorVoucherAction
  | ErrorPaymentIntentAction
  | BookingUpdateBoatCountAction
  | BookingUpdateDurationAction
  | GiftcardUpdateDurationAction
  | BookingUpdateDateAction
  | SelectedShopIdUpdateShopIdAction
  | TermsUpdateTermsCheckedAction
  | TermsUpdateNewsletterSubscribedAction
  | VoucherUpdateIsOpenAction
  | VoucherUpdateCodeAction
  | PaymentUpdateClientSecretAction
  | PaymentUpdateShowPaymentModalAction;

export interface ErrorReducerState {
  location: string | null;
  boatCount: string | null;
  duration: string | null;
  date: string | null;
  time: string | null;
  booking: string | null;
  bookingUpdate: string | null;
  bookingDate: string | null;
  priceModel: string | null;
  customerForm: string | null;
  terms: string | null;
  newsletter: string | null;
  payment: string | null;
  cancelBooking: string | null;
  voucher: string | null;
  paymentIntent: string | null;
}

export const errorReducerinitialState: ErrorReducerState = {
  location: null,
  boatCount: null,
  duration: null,
  date: null,
  time: null,
  booking: null,
  bookingUpdate: null,
  bookingDate: null,
  priceModel: null,
  customerForm: null,
  terms: null,
  newsletter: null,
  payment: null,
  cancelBooking: null,
  voucher: null,
  paymentIntent: null,
};

const errorReducer = (
  state: ErrorReducerState,
  action: ErrorReducerAction
): ErrorReducerState => {
  switch (action.type) {
    case errorReducerActionTypes.LOCATION_MISSING: {
      return {
        ...state,
        location: action.payload,
      };
    }
    case errorReducerActionTypes.BOATCOUNT_MISSING: {
      return {
        ...state,
        boatCount: action.payload,
      };
    }
    case errorReducerActionTypes.DURATION_MISSING: {
      return {
        ...state,
        duration: action.payload,
      };
    }
    case errorReducerActionTypes.DATE_MISSING: {
      return {
        ...state,
        date: action.payload,
      };
    }
    case errorReducerActionTypes.TIME_MISSING: {
      return {
        ...state,
        time: action.payload,
      };
    }
    case errorReducerActionTypes.BOOKING_CREATE: {
      return {
        ...state,
        booking: action.payload,
      };
    }
    case errorReducerActionTypes.BOOKING_UPDATE: {
      return {
        ...state,
        bookingUpdate: action.payload,
      };
    }
    case errorReducerActionTypes.BOOKING_DATE: {
      return {
        ...state,
        bookingDate: action.payload,
      };
    }
    case errorReducerActionTypes.PRICE_MODEL: {
      return {
        ...state,
        priceModel: action.payload,
      };
    }
    case errorReducerActionTypes.CUSTOMER_FORM: {
      return {
        ...state,
        customerForm: action.payload,
      };
    }
    case errorReducerActionTypes.TERMS: {
      return {
        ...state,
        terms: action.payload,
      };
    }
    case errorReducerActionTypes.NEWSLETTER: {
      return {
        ...state,
        newsletter: action.payload,
      };
    }
    case errorReducerActionTypes.PAYMENT: {
      return {
        ...state,
        payment: action.payload,
      };
    }
    case errorReducerActionTypes.CANCEL_BOOKING: {
      return {
        ...state,
        cancelBooking: action.payload,
      };
    }
    case errorReducerActionTypes.VOUCHER: {
      return {
        ...state,
        voucher: action.payload,
      };
    }
    case errorReducerActionTypes.PAYMENT_INTENT: {
      return {
        ...state,
        paymentIntent: action.payload,
      };
    }
    case bookingActionTypes.UPDATE_BOAT_COUNT: {
      return {
        ...state,
        boatCount: null,
      };
    }
    case bookingActionTypes.UPDATE_DURATION:
    case giftcardReducerActionTypes.UPDATE_DURATION: {
      return {
        ...state,
        duration: '',
      };
    }
    case bookingActionTypes.UPDATE_DATE: {
      return {
        ...state,
        booking: '',
      };
    }
    case selecetedShopIdActionTypes.SELECTED_SHOP_ID_UPDATE: {
      return {
        ...state,
        location: null,
      };
    }
    case termsReducerActionTypes.UPDATE_TERMS_CHECKED: {
      return {
        ...state,
        terms: null,
      };
    }
    case termsReducerActionTypes.UPDATE_NEWSLETTER_SUBSCRIBED: {
      return {
        ...state,
        newsletter: null,
      };
    }
    case voucherReducerActionTypes.UPDATE_IS_OPEN:
    case voucherReducerActionTypes.UPDATE_CODE:
    case paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL: {
      return {
        ...state,
        voucher: '',
      };
    }
    case paymentReducerActionTypes.UPDATE_CLIENT_SECRET: {
      return {
        ...state,
        paymentIntent: '',
      };
    }
    default:
      return state;
  }
};

export default errorReducer;
